import type { RepairPaymentPayableDto } from '@vatos-pas/common';

export interface PayableRowEdits {
  currentCost?: number | string;
  check?: string;
  /** Luxon DateTime from the row picker, or anything exposing toISO(). */
  paidDate?: { toISO: () => string | null } | null;
}

/**
 * Body for PATCH repair-payment/:id/payable from what the operator edited in
 * the row. Only edited keys are sent: an untouched cost, check or date is left
 * alone by the API (which also locks the cost at the calculated cost on the
 * first submit), so nothing read from the row is echoed back.
 */
export function buildPayablePayload(
  edits: PayableRowEdits | undefined,
): RepairPaymentPayableDto {
  const payload: RepairPaymentPayableDto = {};
  if (!edits) return payload;

  if (
    edits.currentCost !== undefined &&
    edits.currentCost !== null &&
    `${edits.currentCost}`.trim() !== ''
  ) {
    payload.currentCost = parseFloat(`${edits.currentCost}`);
  }
  if (edits.check) {
    payload.check = edits.check;
  }
  const paidDate = edits.paidDate?.toISO();
  if (paidDate) {
    payload.paidDate = paidDate;
  }

  return payload;
}
